import { useRef, useState } from 'react'
import { useUnSubscribe } from './hooks/useUnSubscribe'
import { useSubscribe } from './hooks/useSubscribe'
import { useWsEvents } from './hooks/useWsEvents'
import { useConnect } from './hooks/useConnect'
import { WsSubscribeMessage } from '../types'

export const useWebSocket = () => {
  const [isReady, setReady] = useState(false)
  const { socket } = useConnect({ onReady: setReady })
  const serverSubscriptions = useRef<WsSubscribeMessage[]>([])

  useWsEvents({ onReady: setReady, socket, serverSubscriptions })
  useSubscribe({ isReady, socket, serverSubscriptions })
  useUnSubscribe({ isReady, socket, serverSubscriptions })
}
